import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  SecondaryButton,
  PrimaryButton,
  TextInput,
  SelectBoxForAuth,
} from '../components/UIkit'
import {
  getUsername,
  getUserInfo,
  getUserRole,
} from '../reducks/users/selectors'
import { push } from 'connected-react-router'
import { makeStyles } from '@material-ui/core'
import LanguageIcon from '@mui/icons-material/Language'
import SelectUser from '../components/User/SelectUser'
import { updateRole } from '../reducks/users/operations'
import HeaderController from '../components/features/UserEdit/HeaderController'
import TableArea from '../components/features/UserEdit/table/TableArea'
import { collection, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'
import { PERMISSIONS } from '../constants/permissions'

const useStyle = makeStyles((theme) => ({
  userNumber: {
    display: 'flex',
    alignItems: 'center',
  },
  languageButton: {
    marginTop: '20px',
    width: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#757575',
  },
}))
const UsersEdit = () => {
  const dispatch = useDispatch()
  const classes = useStyle()
  const [users, setUsers] = useState([])
  useEffect(() => {
    const usersRef = collection(db, 'users')
    const unsubscribe = onSnapshot(usersRef, (snapshot) => {
      const updatedUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      setUsers(updatedUsers)
    })

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe()
  }, [])

  const transition = useCallback((path) => {
    dispatch(push(path))
  }, [])

  const userRole = useSelector(getUserRole)
  const isAdministrator = userRole === PERMISSIONS.ADMINISTRATOR
  //firestoreのスナップショットを監視
  return (
    <section>
      {/* <div className="c-section-wrapin"> */}
      <HeaderController />
      <TableArea users={users} isAdmin={isAdministrator} />
      {/* </div> */}
    </section>
  )
}

export default UsersEdit
